<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-auto position-relative">
                <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">White label web</h2>
                <loader v-if="loading" :radius="10" :stroke="2"></loader>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <form @submit.prevent="">
                    <fieldset>
                        <div class="form-group">
                            <label class="font-sm">White label website URL</label>
                            <i class="material-icons">link</i>
                            <input name="white-label-url" ref="whiteLabelUrl" type="text" class="form-control input-style" v-model="userWhiteLabelUrl" readonly /> 
                            <button @click.prevent="" type="button" class="btn btn-light btn-append" @click.prevent="copyWhiteLabelUrl">Copy</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>

        <table v-if="userSettings" class="table table-hover margin-top-30">
            <tbody>
                <tr>
                    <td>
                        <span class="blue">Include your logo on the “White label website”</span>
                        </td>
                    <td class="text-right">
                        <toggle-button :height="24" color="#2196F3" v-model="userSettings.payload.white_label_website.show_logo" :sync="true" @change="setSettingValue('show_logo', $event.value)"></toggle-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="blue">Include your “Company name” on the “White label website”</span>
                        </td>
                    <td class="text-right">
                        <toggle-button :height="24" color="#2196F3" v-model="userSettings.payload.white_label_website.show_company_name" :sync="true" @change="setSettingValue('show_company_name', $event.value)"></toggle-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="blue">Include your “Phone number” on the “White label website”</span>
                    </td>
                    <td class="text-right">
                        <toggle-button :height="24" color="#2196F3" v-model="userSettings.payload.white_label_website.show_phone_number" :sync="true" @change="setSettingValue('show_phone_number', $event.value)"></toggle-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="blue">Include your “Email address” on the “White label website”</span>
                    </td>
                    <td class="text-right">
                        <toggle-button :height="24" color="#2196F3" v-model="userSettings.payload.white_label_website.show_email" :sync="true" @change="setSettingValue('show_email', $event.value)"></toggle-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span class="blue">Include “Get a Quote” functionality on the “White label website”</span>
                    </td>
                    <td class="text-right">
                        <toggle-button :height="24" color="#2196F3" v-model="userSettings.payload.white_label_website.show_get_quote" :sync="true" @change="setSettingValue('show_get_quote', $event.value)"></toggle-button>
                    </td>
                </tr>
                <div v-if="modified" class="row margin-top-20 margin-bottom-20 justify-content-center">
                    <div class="col-auto">
                        <button @click="saveSettings" class="btn btn-primary btn-lg text-uppercase" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Save
                        </button>
                    </div>
                </div>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Loader from "./Loader"
    import { mapGetters, mapActions } from 'vuex'
    import { ToggleButton } from 'vue-js-toggle-button'

    export default {
        components: { Loader, ToggleButton },

        created() {
            this.$store.dispatch("UserSettings/initializeData");
        },

        computed: {
            userWhiteLabelUrl() {
                return this.globalSettings.whiteLabel.url + "/" + (this.userSettings ? this.userSettings.uuid : "");
            },

            ...mapGetters({
                userSettings: "UserSettings/settings",
                loading: "UserSettings/loading",
                modified: "UserSettings/modified",
            }),
        },

        data() {
            return {
                globalSettings: this.$globalVariables.get("settings"),
            }
        },

        methods: {
            ...mapActions({
                saveSettings: 'UserSettings/saveSettings'
            }),

            copyWhiteLabelUrl() {
                this.$refs.whiteLabelUrl.select();
                let success = false;

                try {
                    success = document.execCommand('copy');
                } catch (ignore) {}

                const title = success ? "Success" : "Error";
                const body = success ? "URL copied to your clipboard." : "Sorry, we could not copy the URL to your clipboard. You would have to do it manually.";
                const method = success ? "success" : "error";

                let html = `
                    <div class="snotifyToast__title"><strong>${title}</strong></div>
                    <div class="snotifyToast__body" style="width: 100%">${body}</div>
                `;

                this.$snotify[method]("", {html});
            },

            setSettingValue(name, value) {
                this.$store.dispatch("UserSettings/setWhiteLabelSettingValue", {
                    name: name,
                    value: value,
                });
            }
        }
    }
</script>